import type { CaravanAd } from "@mobility-item-page/types";
import { KeyInfo } from "../../key-info/KeyInfo.tsx";
import { AnnualTax } from "../AnnualTax.tsx";
import { Width } from "../boat/Width.tsx";
import { ChassisNumber } from "../ChassisNumber.tsx";
import { Condition } from "../Condition.tsx";
import { ConditionReport } from "../ConditionReport.tsx";
import { LengthCm } from "../LengthCm.tsx";
import { Make } from "../Make.tsx";
import { Mileage } from "../Mileage.tsx";
import { ModelYear } from "../ModelYear.tsx";
import { NoOfSleepers } from "../NoOfSleepers.tsx";
import { RegistrationNumber } from "../RegistrationNumber.tsx";
import { RegistrationTax } from "../RegistrationTax.tsx";
import { SpecificationsArea } from "../SpecificationsArea.tsx";
import { TradeType } from "../TradeType.tsx";
import { Warranty } from "../Warranty.tsx";
import { RVWeight } from "../Weight.tsx";
import { CaravanLocation } from "./CaravanLocation.tsx";
import { InteriorLength } from "./InteriorLength.tsx";
import { Segment } from "./Segment.tsx";

export const CaravanSpecifications = ({ ad }: { ad: CaravanAd }) => {
  return (
    <SpecificationsArea>
      <KeyInfo>
        {/*Tax information*/}
        <RegistrationTax {...(ad.price ?? {})} />
        <AnnualTax annualTaxUrl={ad.annual_tax_url} />

        {/*General information*/}
        <Condition condition={ad.condition} />
        <Make make={ad.make} />
        <ModelYear year={ad.year} />
        <Segment segment={ad.segment} />

        {/*Product properties*/}
        <LengthCm lengthCm={ad.length?.total} />
        <InteriorLength length={ad.length} />
        <Width width={ad.width} />
        <RVWeight weight={ad.weight} />
        <NoOfSleepers noOfSleepers={ad.no_of_sleepers} />
        <Mileage distance={ad.mileage} unit={ad.mileage_unit} />

        {/*Appearance*/}

        {/*Registration, warranty, owners, etc*/}
        <CaravanLocation caravanLocation={ad.caravan_location} />
        <RegistrationNumber registrationNumber={ad.registration_number} />
        <ChassisNumber chassisNumber={ad.chassis_number} />
        <Warranty warranty={ad.warranty} />
        <ConditionReport conditionReport={ad.condition_report} />
        <TradeType tradeType={ad.trade_type} />
      </KeyInfo>
    </SpecificationsArea>
  );
};
